import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/constants";
import { Bell, Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

export function NotificationBell() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } catch {}
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);

  const unread = items.filter((i) => !i.read).length;

  const openItem = async (n) => {
    try {
      await api.post(`/notifications/${n.id}/read`);
    } catch {}
    load();
    if (n.report_id) navigate(`/reports/${n.report_id}`);
  };

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="notification-bell"
          className="relative rounded-md p-2 text-slate-600 hover:bg-slate-100"
        >
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span
              data-testid="notification-count"
              className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-rose-500 px-1 text-[10px] font-bold text-white"
            >
              {unread}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between border-b border-slate-100 px-3 py-2">
          <span className="text-sm font-semibold">Notifikasi</span>
          {unread > 0 && (
            <Button
              data-testid="mark-all-read-btn"
              variant="ghost"
              size="sm"
              className="h-7 text-xs"
              onClick={markAll}
            >
              <Check className="mr-1 h-3 w-3" /> Tandai dibaca
            </Button>
          )}
        </div>
        <div className="thin-scroll max-h-80 overflow-y-auto">
          {items.length === 0 && (
            <div className="px-3 py-8 text-center text-sm text-slate-400">
              Belum ada notifikasi
            </div>
          )}
          {items.map((n) => (
            <button
              key={n.id}
              data-testid="notification-item"
              onClick={() => openItem(n)}
              className={`block w-full border-b border-slate-50 px-3 py-2.5 text-left hover:bg-slate-50 ${!n.read ? "bg-blue-50/40" : ""}`}
            >
              <p className="text-sm text-slate-700">{n.message}</p>
              <p className="mt-0.5 text-xs text-slate-400">{fmtDate(n.created_at)}</p>
            </button>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
